import styled from "styled-components";
import Select from "../../storybook/Select";

export const PropertySelect = styled(Select)``